import React from 'react';

interface GiftModalProps {
  isOpen: boolean;
  imageSrc: string | null;
  onClose: () => void;
  onClaim: () => void;
  claimDisabled?: boolean;
}

const GiftModal: React.FC<GiftModalProps> = ({ isOpen, imageSrc, onClose, onClaim, claimDisabled }) => {
  if (!isOpen) return null;

  return (
    <div className="gift-modal-overlay">
      <div className="gift-modal">
        <button className="gift-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="gift-modal-title">
          Поздравляем,
          <br />
          тебе подарили подарок!
        </div>

        <div className="gift-modal-media">
          {imageSrc ? (
            <img src={imageSrc} alt="Gift" className="gift-modal-tgs" />
          ) : (
            <div className="gift-modal-fallback" />
          )}
        </div>

        <button className="gift-modal-cta" onClick={onClaim} disabled={!!claimDisabled}>
          Забрать подарок
        </button>
      </div>
    </div>
  );
};

export default GiftModal;
